/* tslint:disable */

/**
 * Inicializaión de la clase LiveAbroadModel, modelo si el usuario cumple con vivir en el exterior
 * 
 * *Set LiveAbroadModel class, model if the user complies with living abroad*
 * 
 * @access public
 * @type {class}
 */
export class LiveAbroadModel {
  /**
   * Identificación del elemento
   * 
   * *Element Id*
   * 
   * @type {number} elementId
   */
  elementId: number;

  /**
   * Valor del elemento
   * 
   * *Element value*
   * 
   * @type {string} value
   */
  value: string;

  /**
   * Revisión del elemento
   * 
   * *Element Checking*
   * 
   * @type {boolean} checked
   */
  checked: boolean;
}

/**
 * Inicializaión de la clase ObjectCheckModel
 * 
 * *Set ObjectCheckModel class*
 * 
 * @access public
 * @type {class}
 */
export class ObjectCheckModel {
  /**
   * Identificación del elemento
   * 
   * *Element Id*
   * 
   * @type {string} elementId
   */
  elementId: string;

  /**
   * Valor del elemento
   * 
   * *Element value*
   * 
   * @type {string} value
   */
  value?: string;

  /**
   * Label del elemento
   * 
   * *Element label*
   * 
   * @type {string} label
   */
  label: string;

  /**
   * Revisión del elemento
   * 
   * *Element Checking*
   * 
   * @type {boolean} checked
   */
  checked: boolean;
}
